import { useTranslation } from "react-i18next";
import { GET_PARTY_STATUSES } from "../payeeTable/constants";
import { UserProfile } from "../../../setup/api/services/contract/models";

export const MilestonePartyStatus = ({
  party,
  partyStatus,
  statusColor,
}: {
  party: Partial<UserProfile>;
  partyStatus?: string;
  statusColor?: string;
}) => {
  const { t } = useTranslation();
  const partiesStatuses = GET_PARTY_STATUSES(t);

  return (
    <p
      className="p3"
      style={{
        marginInline: 0,
        color:
          statusColor ||
          (party.status
            ? partiesStatuses?.[party?.status]?.textColor
            : "#F4B53F"),
      }}>
      {partyStatus ||
        (party.status
          ? partiesStatuses?.[party?.status]?.title
          : t("lbl_pending_payment"))}
    </p>
  );
};
